/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SendMRIContextRequest} from '@cash-web/protos/squareup/cash/deviceintegritly/api/service.pb'
import {SendMRIContextResponse} from '@cash-web/protos/squareup/cash/deviceintegritly/api/service.pb'


export const sendMRIContext = (request: SendMRIContextRequest, options?: CashRequestOptions) => post<SendMRIContextRequest, SendMRIContextResponse>("/2.0/cash/send-m-r-i-context", request, {...options, rejectOnError: true })